import React, { Component } from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { modal } from "../modal";
import { openPhonecall } from "../../common/callUtil"
//import {  hideChat } from "../../lib/synalio";
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { DynamicContent, isVisibleContent } from "../../common/DynamicContent";

const modal_result_impl = props => {
  console.log('modal_result_impl', props);
  //hideChat();
  return (
    <div className="modal_result modal_base"
        style={{ width: "35vw", height: "9vh" }}
    >
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title" style={{ "white-space": "pre-wrap", lineHeight: "unset" }}>
        <br/>
        {props.mode == "update" ? 
            "利用開始日を登録しました。" : "キャンセルしました。"
        } 
      </div>
    </div>
  );
};

export const modal_result = props => {
  console.log('modal_result', props);
  return <MasterDataReady schemaIds={["excComment"]} render={() => {
    if (isVisibleContent(masterData.excComment.modalVisitor)) {
      const { type } = props;
      return (
        <div className="modal_result modal_base">
          <div className="cross" onClick={() => modal.closeModal()} />
          <DynamicContent params={masterData.excComment.modalVisitor} type={type}></DynamicContent>
        </div>
      );
    } else {
      return modal_result_impl(props);
    }
  }}>
  </MasterDataReady>
};



// WEBPACK FOOTER //
// ./common/modal/modal_result.jsx